<template>
  <ul class="tab-bar">
    <li class="tab-bar-item" @click="close">
      <router-link :to="{ path: '/', query: { key: 'home' } }" :exact-active-class="activeClass">
        <BaseIcon class="tab-bar-item__icon" size="25"><IconHome /></BaseIcon>
        ホーム
      </router-link>
    </li>
    <li class="tab-bar-item" @click="close">
      <router-link to="/schedules/daily" :exact-active-class="activeClass">
        <BaseIcon class="tab-bar-item__icon" size="25"><IconList /></BaseIcon>
        番組表
      </router-link>
    </li>
    <li class="tab-bar-item" @click="close">
      <router-link to="/search" :exact-active-class="activeClass">
        <BaseIcon class="tab-bar-item__icon" size="25"><IconSearch /></BaseIcon>
        検索
      </router-link>
    </li>

    <li class="tab-bar-item" @click="close">
      <router-link to="/mylist" :exact-active-class="activeClass">
        <BaseIcon class="tab-bar-item__icon" size="25"><IconMylist /></BaseIcon>
        お気に入り
      </router-link>
    </li>

    <li class="tab-bar-item" @click="openPresent">
      <button type="button" class="tab-bar-item__button">
        <BaseIcon class="tab-bar-item__icon" size="25"><IconPresent /></BaseIcon>
        プレゼント
      </button>
    </li>

    <li class="tab-bar-item" @click="close">
      <router-link to="/other" :exact-active-class="activeClass">
        <BaseIcon class="tab-bar-item__icon" size="25"><IconDotsCircleOutline /></BaseIcon>
        その他
      </router-link>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed, ref, inject } from 'vue';
import { useFlutterConnection } from '@/composables/useFlutterConnection';
import { ProgramModalKey } from '@/composables/useProgramModal';
import { openPresentPage } from '@/utils/presentNavigation';

const _shownMenu = ref(false);
const shownMenu = computed(() => _shownMenu.value);
const activeClass = computed(() => (shownMenu.value ? undefined : 'active'));

const programModalInjection = inject(ProgramModalKey);
if (!programModalInjection) throw new Error(`${ProgramModalKey} NOT PROVIDE`);
const { close } = programModalInjection;

const { openNewWebView } = useFlutterConnection();

const openPresent = async () => {
  close();
  await openPresentPage(openNewWebView);
};
</script>

<style scoped lang="scss">
.tab-bar {
  color: #fff;
  background: #121e39;
  list-style: none;
  height: $tab-bar-height;
  position: sticky;
  bottom: 0;
  display: flex;
  font-size: 9px;
  z-index: 300;
}

.tab-bar-item {
  &,
  > a,
  > span,
  > button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    width: 100%;
    height: 100%;
  }

  &__icon {
    margin-bottom: 5px;
  }

  .active {
    color: #eb5757;
  }
}

.tab-bar-item__button {
  background: transparent;
  border: 0;
  padding: 0;
  font: inherit;
  cursor: pointer;
}
</style>
